import { useEffect, useState } from "react";
import { api, getApiUrl } from "../../utils/apiConfig";

// The stored destination can mislabel imported PMax as Search. Ask the API
// before showing the action; its live channel type is authoritative.
export default function UpdateCreativeButton({
  campaignId,
  accountId,
  userId,
  onClick,
}) {
  const [eligible, setEligible] = useState(false);
  const [lookupFailed, setLookupFailed] = useState(false);
  useEffect(() => {
    let live = true;
    setEligible(false);
    setLookupFailed(false);
    api
      .get(
        getApiUrl(
          `/api/v2/campaigns/${campaignId}/creative-update/eligibility`,
        ),
        { params: { accountId, userId } },
      )
      .then(() => {
        if (live) setEligible(true);
      })
      .catch((error) => {
        if (!live) return;
        const status = error.response?.status;
        // Known exclusions stay hidden. A failed lookup is not evidence that
        // this campaign is ineligible; the workflow can show the error/retry.
        if ([403, 404].includes(status) ||
            error.response?.data?.code === "UNSUPPORTED_CAMPAIGN") return;
        setLookupFailed(true);
      });
    return () => {
      live = false;
    };
  }, [campaignId, accountId, userId]);
  if (!eligible && !lookupFailed) return null;
  return (
    <div style={{ marginLeft: "auto", alignSelf: "flex-start" }}>
    <button
      type="button"
      className="btn btn-primary"
      onClick={onClick}
    >
      Update creative
    </button>
    {lookupFailed && <small role="status" style={{ display: "block" }}>
      Couldn’t check creative updates. Open to retry.
    </small>}
    </div>
  );
}
